export default __webpack_public_path__ + "static/media/45a8744e6fceea44.3d3cd726038a35b7050aa6d5d54e46a3.svg";